import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack } from '@mui/material';
import { BentoThemeProvider } from '@zenput/ui-bento';

interface ConfirmDialogProps {
    open: boolean;
    title: string;
    description: string;
    confirmLabel: string;
    onConfirm: () => void;
    cancelLabel: string;
    onCancel?: () => void;
    onClose?: () => void;
}

export const ConfirmDialog = (props: ConfirmDialogProps) => {
    const {
        open,
        title,
        description,
        confirmLabel,
        onConfirm,
        cancelLabel,
        onCancel = () => {},
        onClose = () => {}
    } = props;

    return (
        <BentoThemeProvider>
            <Dialog open={open} onClose={onClose}>
                <DialogTitle>{title}</DialogTitle>

                <DialogContent>
                    <DialogContentText sx={{ whiteSpace: 'pre-wrap' }}>{description}</DialogContentText>
                </DialogContent>

                <DialogActions
                    sx={{
                        justifyContent: 'center'
                    }}
                >
                    <Stack
                        sx={{
                            width: '100%'
                        }}
                        gap={2}
                    >
                        <Button onClick={onConfirm} variant="contained">
                            {confirmLabel}
                        </Button>

                        <Button variant="text" onClick={onCancel}>
                            {cancelLabel}
                        </Button>
                    </Stack>
                </DialogActions>
            </Dialog>
        </BentoThemeProvider>
    );
};
